export default "__VITE_ASSET__aPzn3Ah7__"